const { VUE_APP_API_BASE_URL } = process.env

const API_URL = VUE_APP_API_BASE_URL

export { API_URL }

